import { fetch } from './fetch'
import api from './url'

// 区域接口：region 通过 header 指定，避免误用全局选中的区域
function regionFetch(options, region) {
    if (region) {
        options.headers = Object.assign({}, options.headers, { region: region })
    }
    return fetch(options)
}

export default {
    // 套餐管理
    PackageCreate: function(params) {
        return fetch({
            url: api.PackageCreate,
            method: 'post',
            data: params
        })
    },
    PackageUpdate: function(params) {
        return fetch({
            url: api.PackageUpdate,
            method: 'post',
            data: params
        })
    },
    PackageUpdatePrice: function(params) {
        return fetch({
            url: api.PackageUpdatePrice,
            method: 'post',
            data: params
        })
    },
    PackageList: function(params) {
        return fetch({
            url: api.PackageList,
            method: 'get',
            params: params
        })
    },
    PackageStatus: function(params) {
        return fetch({
            url: api.PackageStatus,
            method: 'post',
            data: params
        })
    },
    PackageChangeStatus: function(params) {
        return fetch({
            url: api.PackageChangeStatus,
            method: 'post',
            data: params
        })
    },
    PackDelete: function(params) {
        return fetch({
            url: api.PackDelete,
            method: 'post',
            data: params
        })
    },
    PackageDetail: function(params) {
        return fetch({
            url: api.PackageDetail,
            method: 'get',
            params: params
        })
    },
    // 套餐折扣
    PackSaleUpdate: function(params) {
        return fetch({
            url: api.PackSaleUpdate,
            method: 'post',
            data: params
        })
    },
    PackSaleList: function(params) {
        return fetch({
            url: api.PackSaleList,
            method: 'get',
            params: params
        })
    },
    PackSaleDelete: function(params) {
        return fetch({
            url: api.PackSaleDelete,
            method: 'post',
            data: params
        })
    },
    PackSaleDetail: function(params) {
        return fetch({
            url: api.PackSaleDetail,
            method: 'get',
            params: params
        })
    },
    // 产品套餐分配
    ProPackDistriUpdate: function(params) {
        return fetch({
            url: api.ProPackDistriUpdate,
            method: 'post',
            data: params
        })
    },
    ProPackDistriList: function(params) {
        return fetch({
            url: api.ProPackDistriList,
            method: 'get',
            params: params
        })
    },
    ProPackDistriListNew: function(params) {
        return fetch({
            url: api.ProPackDistriListNew,
            method: 'get',
            params: params
        })
    },
    ProPackDistriDelete: function(params) {
        return fetch({
            url: api.ProPackDistriDelete,
            method: 'post',
            data: params
        })
    },
    // 规则套餐分配
    RulePackDistriList: function(params) {
        return fetch({
            url: api.RulePackDistriList,
            method: 'get',
            params: params
        })
    },
    RulePackDistriCreate: function(params) {
        return fetch({
            url: api.RulePackDistriCreate,
            method: 'post',
            data: params,
            headers: {
                region: params.region
            }
        })
    },
    RulePackDistriDelete: function(params) {
        return fetch({
            url: api.RulePackDistriDelete,
            method: 'post',
            data: params,
            headers: {
                region: params.region
            }
        })
    },
    // 套餐关联国家
    PackCountryList: function(params) {
        return fetch({
            url: api.PackCountryList,
            method: 'get',
            params: params
        })
    },
    PackCountrySet: function(params) {
        return fetch({
            url: api.PackCountrySet,
            method: 'post',
            data: params
        })
    },
    PackCountryDelete: function(params) {
        return fetch({
            url: api.PackCountryDelete,
            method: 'post',
            data: params
        })
    },
    // 区域配置
    ReginUpdate: function(params) {
        return fetch({
            url: api.ReginUpdate,
            method: 'post',
            data: params
        })
    },
    ReginList: function(params) {
        return fetch({
            url: api.ReginList,
            method: 'get',
            params: params
        })
    },
    ReginDelete: function(params) {
        return fetch({
            url: api.ReginDelete,
            method: 'post',
            data: params
        })
    },
    ReginDetail: function(params) {
        return fetch({
            url: api.ReginDetail,
            method: 'get',
            params: params
        })
    },
    // 套餐功能组
    PackFuncList: function(params) {
        return fetch({
            url: api.PackFuncList,
            method: 'get',
            params: params
        })
    },
    CouponList: function(params) {
        return fetch({
            url: api.CouponList,
            method: 'get',
            params: params
        })
    },
    CouponCreate: function(params) {
        return fetch({
            url: api.CouponCreate,
            method: 'post',
            data: params
        })
    },
    // 4G套餐管理
    FourGPackageCreate: function(params) {
        return fetch({
            url: api.FourGPackageCreate,
            method: 'post',
            data: params
        })
    },
    FourGPackageUpdateRegion: function(params) {
        return fetch({
            url: api.FourGPackageUpdateRegion,
            method: 'put',
            data: params
        })
    },
    FourGPackageUpdatePrice: function(params) {
        return fetch({
            url: api.FourGPackageUpdatePrice,
            method: 'put',
            data: params
        })
    },
    FourGPackageList: function(params) {
        return fetch({
            url: api.FourGPackageList,
            method: 'get',
            params: params
        })
    },
    FourGPackageDetail: function(params) {
        return fetch({
            url: api.FourGPackageDetail,
            method: 'get',
            params: params
        })
    },
    FourGPackageUpdateStatus: function(params) {
        return fetch({
            url: api.FourGPackageUpdateStatus,
            method: 'put',
            data: params
        })
    },
    FourGPackageExtFeaturesList: function(params) {
        return fetch({
            url: api.FourGPackageExtFeaturesList,
            method: 'get',
            params: params
        })
    },
    FourGPackageExtFeaturesUpdate: function(params) {
        return fetch({
            url: api.FourGPackageExtFeaturesUpdate,
            method: 'post',
            data: params
        })
    },
    FourGPackageExtFeaturesDelete: function(params) {
        return fetch({
            url: api.FourGPackageExtFeaturesDelete,
            method: 'post',
            data: params
        })
    },
    // Alarm套餐管理
    AlarmPackageCreate: function(params) {
        return fetch({
            url: api.AlarmPackageCreate,
            method: 'post',
            data: params
        })
    },
    AlarmPackageUpdateRegion: function(params) {
        return fetch({
            url: api.AlarmPackageUpdateRegion,
            method: 'post',
            data: params
        })
    },
    AlarmPackageUpdatePrice: function(params) {
        return fetch({
            url: api.AlarmPackageUpdatePrice,
            method: 'post',
            data: params
        })
    },
    AlarmPackageList: function(params) {
        return fetch({
            url: api.AlarmPackageList,
            method: 'get',
            params: params
        })
    },
    AlarmPackageDetail: function(params) {
        return fetch({
            url: api.AlarmPackageDetail,
            method: 'get',
            params: params
        })
    },
    AlarmPackageUpdateStatus: function(params) {
        return fetch({
            url: api.AlarmPackageUpdateStatus,
            method: 'post',
            data: params
        })
    },
    // 打猎相机套餐管理
    HuntingPackageCreate: function(params) {
        return fetch({ url: api.HuntingPackageCreate, method: 'post', data: params })
    },
    HuntingPackageList: function(params) {
        return fetch({ url: api.HuntingPackageList, method: 'get', params: params })
    },
    HuntingPackageDetail: function(params) {
        return fetch({ url: api.HuntingPackageDetail, method: 'get', params: params })
    },
    HuntingPackageUpdateStatus: function(params) {
        return fetch({ url: api.HuntingPackageUpdateStatus, method: 'post', data: params })
    },
    HuntingPackageUpdatePrice: function(params) {
        return fetch({ url: api.HuntingPackageUpdatePrice, method: 'post', data: params })
    },
    HuntingPackageUpdateRegion: function(params) {
        return fetch({ url: api.HuntingPackageUpdateRegion, method: 'post', data: params })
    },
    HuntingPackageRegions: function(params) {
        return fetch({ url: api.HuntingPackageRegions, method: 'get', params: params })
    },
    HuntingPackageModelList: function(params) {
        return fetch({ url: api.HuntingPackageModelList, method: 'get', params: params })
    },
    HuntingPackageModelCreate: function(params) {
        return fetch({ url: api.HuntingPackageModelCreate, method: 'post', data: params })
    },
    HuntingPackageModelDelete: function(params) {
        return fetch({ url: api.HuntingPackageModelDelete, method: 'post', data: params })
    },
    HuntingPackageFeatureDictList: function(params) {
        return fetch({ url: api.HuntingPackageFeatureDictList, method: 'get', params: params })
    },
    HuntingPackageFeatureDictAll: function(params) {
        return fetch({ url: api.HuntingPackageFeatureDictAll, method: 'get', params: params })
    },
    HuntingPackageFeatureDictCreate: function(params) {
        return fetch({ url: api.HuntingPackageFeatureDictCreate, method: 'post', data: params })
    },
    HuntingPackageFeatureDictUpdate: function(params) {
        return fetch({ url: api.HuntingPackageFeatureDictUpdate, method: 'post', data: params })
    },
    HuntingPackageFeatureDictDelete: function(params) {
        return fetch({ url: api.HuntingPackageFeatureDictDelete, method: 'post', data: params })
    },
    // 宠物App云套餐管理（仅全球节点生效，固定 region=gb）
    PetPackageList: function(params) {
        return regionFetch({ url: api.PetPackageList, method: 'get', params: params }, 'gb')
    },
    PetPackageDetail: function(params) {
        return regionFetch({ url: api.PetPackageDetail, method: 'get', params: params }, 'gb')
    },
    PetPackageCreate: function(params) {
        return regionFetch({ url: api.PetPackageCreate, method: 'post', data: params }, 'gb')
    },
    PetPackageUpdate: function(params) {
        return regionFetch({ url: api.PetPackageUpdate, method: 'post', data: params }, 'gb')
    },
    PetPackageUpdatePrice: function(params) {
        return regionFetch({ url: api.PetPackageUpdatePrice, method: 'post', data: params }, 'gb')
    },
    PetPackagePriceStatus: function(params) {
        return regionFetch({ url: api.PetPackagePriceStatus, method: 'post', data: params }, 'gb')
    },
    PetPackageUpdateStatus: function(params) {
        return regionFetch({ url: api.PetPackageUpdateStatus, method: 'post', data: params }, 'gb')
    },
    PetPackageUpdateRegion: function(params) {
        return regionFetch({ url: api.PetPackageUpdateRegion, method: 'post', data: params }, 'gb')
    },
    PetPackageRegions: function(params) {
        return regionFetch({ url: api.PetPackageRegions, method: 'get', params: params }, 'gb')
    },
    PetPackageModelList: function(params) {
        return regionFetch({ url: api.PetPackageModelList, method: 'get', params: params }, 'gb')
    },
    PetPackageModelGet: function(params) {
        return regionFetch({ url: api.PetPackageModelGet, method: 'get', params: params }, 'gb')
    },
    // 全量替换型号关联
    PetPackageModelUpdate: function(params) {
        return regionFetch({ url: api.PetPackageModelUpdate, method: 'post', data: params }, 'gb')
    },
    PetPackageModelDelete: function(params) {
        return regionFetch({ url: api.PetPackageModelDelete, method: 'post', data: params }, 'gb')
    },
    PetPackageFeatureList: function(params) {
        return regionFetch({ url: api.PetPackageFeatureList, method: 'get', params: params }, 'gb')
    },
    PetPackageFeatureUpdate: function(params) {
        return regionFetch({ url: api.PetPackageFeatureUpdate, method: 'post', data: params }, 'gb')
    },
    PetPackageFeatureDelete: function(params) {
        return regionFetch({ url: api.PetPackageFeatureDelete, method: 'post', data: params }, 'gb')
    },
    // 后台开通/关闭宠物套餐（客服补偿用，操作人由服务端从登录态取）
    PetCloudInfoOpen: function(params) {
        return regionFetch({ url: api.PetCloudInfoOpen, method: 'post', data: params }, 'gb')
    },
    PetCloudInfoShutdown: function(params) {
        return regionFetch({ url: api.PetCloudInfoShutdown, method: 'post', data: params }, 'gb')
    },
    // 打猎相机套餐开通/关闭（后台代客操作，区域接口，region 走 header）
    // 用户打猎相机云套餐记录，返回的 id 即关闭接口的 cloud_info_id
    HuntingCloudList: function(params) {
        const { region, ...query } = params
        return regionFetch(
            { url: api.HuntingCloudList, method: 'get', params: query },
            region
        )
    },
    HuntingCloudCreate: function(params) {
        const { region, ...body } = params
        return regionFetch(
            { url: api.HuntingCloudCreate, method: 'post', data: body },
            region
        )
    },
    HuntingCloudShutdown: function(params) {
        const { region, ...body } = params
        return regionFetch(
            { url: api.HuntingCloudShutdown, method: 'post', data: body },
            region
        )
    },
    PackageLevelList: function(params) {
        return fetch({
            url: api.PackageLevelList,
            method: 'get',
            params: params
        })
    }
}
